// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class Toggler extends WebComponent {

	didMount() {
		const {
			      toggleClass,
			      target,
		      } = this.props;

		this.on('click', (event) => {
			this.element.classList.toggle(toggleClass);
			const targetElement = document.querySelector(target);
			targetElement.classList.toggle(toggleClass);
			const openToggles = document.querySelectorAll(`.${ toggleClass }`);

			[ ...openToggles ].forEach((toggle) => {
				if ( (toggle !== this.element) && (toggle !== targetElement) ) {
					toggle.classList.remove(toggleClass);
				}
			});

			// autofocus search input if fulltext related toggler is pressed
			if ( `${ target }`.match(/fulltext/i) ) {
				const targetHasInput = !!targetElement.querySelector('input[type="text"],input[type="search"]');
				if ( targetHasInput ) {
					const targetInput = targetElement.querySelector('input[type="text"],input[type="search"]');
					targetInput.focus();
				}
			}
		});
	}

}

export default Toggler;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Toggler.js